import React from "react";
import Select from "react-select";

const SelectList = ({
  List,
  defaultName = '',
  handleChangeData,
  placeholder,
  isClearable,
  name = '',
  isMulti = false,
}) => {

  const value = isMulti
    ? Array.isArray(defaultName)
      ? defaultName
      : []
    : defaultName
      ? { value: defaultName, label: defaultName }
      : null;

  return (
    <Select
      placeholder={placeholder}
      options={List}
      value={value}
      name={name}
      onChange={handleChangeData}
      isClearable={isClearable}
      isMulti={isMulti}
      closeMenuOnSelect={!isMulti}
      styles={{
        control: (base) => ({
          ...base,
          borderColor: 'grey',
          minWidth: 200,
          minHeight: 36,
        }),
      
        valueContainer: (base) => ({
          ...base,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingLeft: 8,
          paddingRight: 8,
        }),
      
        singleValue: (base) => ({
          ...base,
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          textAlign: 'center',
          margin: 0,
        
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '100%',
        }),
      
        placeholder: (base) => ({
          ...base,
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          textAlign: 'center',
          margin: 0,
        
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '100%',
        }),
      
        multiValue: (base) => ({
          ...base,
          display: 'flex',
          alignItems: 'center',
        }),
      
        multiValueLabel: (base) => ({
          ...base,
          textAlign: 'center',
        }),
      
        option: (base, state) => ({
          ...base,
           textAlign: 'center',
          backgroundColor: state.isSelected ? 'lightgray' : base.backgroundColor,
          color: state.isSelected ? 'black' : base.color,
        }),
      
        menu: (base) => ({
          ...base,
          zIndex: 9999,
          fontSize: '12px',
        }),
      
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999,
        }),
      }}
      
      menuPortalTarget={document.body}
    />
  );
};

export default SelectList;
